<template>
  <div class="my-1">
    <div class="p-3 text-center bg-white box-shadow">
      <h3 class="pb-3">Search Equipment</h3>
      <v-select
        class="mb-3"
        placeholder="Search Machines By Stock Number"
        label="Title"
        @search="onSearch"
        :options="results"
        :clearSearchOnBlur="onBlur"
                
        :value="selectedMachine"
        @input="setSelected"
      >
        <template v-slot:option="option">
          {{ option.Title }}
        </template>
        <template slot="no-options">Type to search machines</template>
      </v-select>
      <small v-if="isPhotoUploader" class="text-muted"
        >Upload to a <span class="font-weight-bold">single</span> tag
        number.</small
      >
    </div>
  </div>
</template>

<script>
//https://vue-select.org/
import vSelect from "vue-select";
import EquipmentDataService from "../services/EquipmentDataService";
import _ from "lodash";

    export default {
        name: "Search",
        components: {
            vSelect,
        },
        data() {
            return {
                results: [],
                selectedMachine: "",
            };
        },
        // Because Home is kept-alive in App.vue, clear any lingering selected
        // machine when the user returns to the home page so the dropdown is
        // empty and ready for a fresh search.
        activated() {
            this.selectedMachine = "";
            this.results = [];
        },
        computed: {
            isPhotoUploader() {
                return this.$route.name === "PhotoUploader";
            },
        },
        methods: {
            onSearch(search, loading) {
                loading(true);
                this.search(loading, search, this);
            },
            search: _.debounce((loading, search, vm) => {
                let upperSearch = search.toUpperCase();
                EquipmentDataService.searchEquipmentByStockNo(upperSearch).then((result) => {
                    vm.results = result;
                    loading(false);
                });
            }, 500),
            setSelected(value) {
                if (this.isPhotoUploader == true) {
                    this.selectedMachine = value;
                    this.$emit("updateSelectedMachine", this.selectedMachine);
                } else {
                    this.$router.push({
                        name: "PhotoUploader",
                        params: { id: value.id, passedMachine: value },
                    });
                }
            },
            onBlur() {
                return (this.filteredOptions > 0) ? true : false;
            }
        }
};
</script>